import FooterV2 from './FooterV2'
export default FooterV2
